import { APIProvider } from "./api-context";
import { AuthProvider } from "./auth-context";
import { combineComponents } from "./combineContext";

const providers = [APIProvider, AuthProvider];
export const AppContextProvider = combineComponents(...providers);
